/* TFK draft: each main item owns its add-ons via a private group ID. */
(function(){
  if(window.TFKCartGroups) return;
  var serviceIds=['53973973172408','53459121438904','53459121471672','53459121504440','53459063177400','53459063210168'];
  function service(item){var role=(item.properties||{})._tfk_role;return role==='service'||role==='addon'||serviceIds.indexOf(String(item.variant_id))>=0||item.product_type==='Surcharge'||item.product_type==='升級服務';}
  async function request(url,body){
    var response=await fetch(url,body?{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}:{cache:'no-store'});
    var data=await response.json();
    if(!response.ok) throw new Error(data.description||data.message||'購物袋更新失敗');
    return data;
  }
  function attached(cart,main){
    var items=cart.items||[], group=(main.properties||{})._tfk_group;
    if(group) return items.filter(function(item){return service(item)&&(item.properties||{})._tfk_group===group;});
    // Earlier Christmas carts have a tree and poinsettia but no group ID.
    var isTree=function(item){return String(item.handle||'').indexOf('noble-fir-christmas-tree')===0;};
    var trees=items.filter(function(item){return isTree(item)&&!(item.properties||{})._tfk_group;});
    if(isTree(main)&&trees.length===1&&trees[0].key===main.key){
      return items.filter(function(item){
        var props=item.properties||{};
        if(item.key===main.key||props._tfk_group) return false;
        var linked=String(props['對應訂單']||props['Goes with']||'');
        return (service(item)||item.handle==='poinsettia')&&/聖誕樹|Christmas tree/i.test(linked);
      });
    }
    // Old carts have no ownership metadata: infer only when exactly one legacy main exists.
    var mains=items.filter(function(item){return !service(item)&&!(item.properties||{})._tfk_group;});
    return mains.length===1&&mains[0].key===main.key?items.filter(function(item){return service(item)&&!(item.properties||{})._tfk_group;}):[];
  }
  var pendingEdits={},editAliases={},pendingUploads={};
  async function add(items,editKey,transport){
    var requestEditKey=editKey;
    var uploadKey=requestEditKey||'new';
    if(pendingUploads[uploadKey]){
      var partial=await request('/cart.js'),partialCleanup={};
      partial.items.filter(function(item){return (item.properties||{})._tfk_group===pendingUploads[uploadKey];}).forEach(function(item){partialCleanup[item.key]=0;});
      if(Object.keys(partialCleanup).length) await request('/cart/update.js',{updates:partialCleanup});
      delete pendingUploads[uploadKey];
    }
    editKey=editAliases[requestEditKey]||editKey;
    if(requestEditKey && pendingEdits[requestEditKey]){
      var pending=pendingEdits[requestEditKey], retryCart=await request('/cart.js');
      var original=(retryCart.items||[]).find(function(item){return item.key===pending.effectiveKey;});
      var added=(retryCart.items||[]).filter(function(item){return (item.properties||{})._tfk_group===pending.group;});
      if(original){editKey=original.key;var cleanup={};added.forEach(function(item){cleanup[item.key]=0;});if(added.length) await request('/cart/update.js',{updates:cleanup});}
      else {var replacement=added.find(function(item){return !service(item);});if(!replacement) throw new Error('原商品已更新，請返回購物袋核對');editKey=replacement.key;}
      editAliases[requestEditKey]=editKey;
      delete pendingEdits[requestEditKey];
    }
    var cart=editKey?await request('/cart.js'):null;
    var old=cart&&(cart.items||[]).find(function(item){return item.key===editKey;});
    if(editKey&&!old) throw new Error('原商品已移除，請返回購物袋重新選擇');
    var group=window.crypto&&crypto.randomUUID?crypto.randomUUID():'tfk-'+Date.now()+'-'+Math.random().toString(36).slice(2);
    items.forEach(function(item,index){
      var perMain=item.quantity||1;
      item.properties=Object.assign({},item.properties,{_tfk_group:group,_tfk_role:index===0?'main':'service',_tfk_per_main:String(perMain)});
      // PDP edit forms submit one main item; replacing a cart line must retain its quantity.
      if(old) item.quantity=perMain*old.quantity;
    });
    if(transport) pendingUploads[uploadKey]=group;
    var data=transport?await transport(items):await request('/cart/add.js',{items:items});
    delete pendingUploads[uploadKey];
    if(old){
      var updates={};updates[old.key]=0;attached(cart,old).forEach(function(item){updates[item.key]=0;});
      try{await request('/cart/update.js',{updates:updates});}
      catch(error){
        pendingEdits[requestEditKey]={group:group,effectiveKey:editKey};
        try{
          var current=await request('/cart.js');
          // A lost response can follow a successful update: never delete the retained replacement.
          if(!(current.items||[]).some(function(item){return item.key===old.key;})){delete pendingEdits[requestEditKey];delete editAliases[requestEditKey];return data;}
          var rollback={};(current.items||[]).filter(function(item){return (item.properties||{})._tfk_group===group;}).forEach(function(item){rollback[item.key]=0;});
          await request('/cart/update.js',{updates:rollback});delete pendingEdits[requestEditKey];
        }catch(rollbackError){error.message+='；請留在此頁重試以完成原訂單取代';}
        throw error;
      }
    }
    delete editAliases[requestEditKey];
    return data;
  }
  async function change(key,quantity){
    var cart=await request('/cart.js'), main=(cart.items||[]).find(function(item){return item.key===key;});
    if(!main) throw new Error('商品已更新，請重新整理購物袋');
    var updates={};updates[key]=quantity;
    if(!service(main)) attached(cart,main).forEach(function(item){var per=Number((item.properties||{})._tfk_per_main)||1;updates[item.key]=quantity*per;});
    var result=await request('/cart/update.js',{updates:updates});
    if(quantity===0){
      try{var edit=JSON.parse(sessionStorage.getItem('tfkEditData')||'null');if(edit&&edit.key===key){sessionStorage.removeItem('tfkEditData');window.__tfkEditKey=null;}}catch(ignore){}
    }
    return result;
  }
  async function addForm(fd,extras,editKey){
    var props={},hasFile=false;
    for(var entry of fd.entries()){
      var match=entry[0].match(/^properties\[(.+)\]$/);
      if(match){
        if(typeof entry[1]==='string') props[match[1]]=entry[1];
        else if(entry[1].size) hasFile=true;
      }
    }
    var items=[{id:Number(fd.get('id')),quantity:Number(fd.get('quantity')||1),properties:props}].concat(extras||[]);
    if(!hasFile) return add(items,editKey);
    // Preserve Shopify multipart uploads; the old group stays until both adds succeed.
    return add(items,editKey,async function(grouped){
      var main=grouped[0],outgoing=new FormData();
      for(var entry of fd.entries())outgoing.append(entry[0],entry[1]);
      outgoing.set('quantity',String(main.quantity));
      Object.keys(main.properties).forEach(function(key){outgoing.set('properties['+key+']',main.properties[key]);});
      try{
        var response=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:outgoing});
        var result=await response.json();
        if(!response.ok) throw new Error(result.description||result.message||'商品未能加入');
        if(grouped.length>1) await request('/cart/add.js',{items:grouped.slice(1)});
        return result;
      }catch(error){
        // Failed uploads / add-ons must not leave a new main item or alter another order.
        var current=await request('/cart.js'),cleanup={};
        current.items.filter(function(item){return (item.properties||{})._tfk_group===main.properties._tfk_group;}).forEach(function(item){cleanup[item.key]=0;});
        if(Object.keys(cleanup).length) await request('/cart/update.js',{updates:cleanup});
        throw error;
      }
    });
  }
  window.TFKCartGroups={add:add,addForm:addForm,change:change,attached:attached,isService:service};
})();
